export function startLoading() { return { type: "LOADING_START" } }

export function endLoading() { return { type: "LOADING_STOP" } }

export function SnackBar(show=false, message="", variant=null) {
    return { type: 'SHOW_ALERT_MESSAGE', show, message, variant };
}
export function reduxStart() { return { type: 'REDUX_START' }; }

